// extracted by mini-css-extract-plugin
export var chip = "_f3-0";
export var filterDropdown = "_f3-5";
export var filterItem = "_f3-6";
export var icon = "_f3-1";
export var removeButton = "_f3-3";
export var removeIcon = "_f3-4";
export var separator = "_f3-2";